import { Location } from '@angular/common';
import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class NavigationService {
  private router = inject(Router);
  private location = inject(Location);

  back(): void {
    if (history.state?.navigationId > 1) {
      this.location.back();
    } else {
      void this.router.navigateByUrl('/');
    }
  }
}
